/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDealerDetailsForm_viewer$ref = any;
type PdpSharedDealerDetailsStats_viewer$ref = any;
type PdpSharedSellerTabsVariant_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespDealerDetails_viewer$ref: FragmentReference;
export type PdpRespDealerDetails_viewer = {|
  +isMessageCenterEnabled: ?boolean,
  +isReviewsEnabled: ?boolean,
  +isEmbeddedMakeOfferTestDisabled: ?boolean,
  +$fragmentRefs: PdpSharedDealerDetailsStats_viewer$ref & PdpSharedDealerDetailsForm_viewer$ref & PdpSharedSellerTabsVariant_viewer$ref,
  +$refType: PdpRespDealerDetails_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isReviewsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ORDER_FEEDBACK",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isEmbeddedMakeOfferTestDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disablePdpEmbeddedMakeOfferTest",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"disablePdpEmbeddedMakeOfferTest\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsStats_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsForm_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4ae4585962fde868cfbe4a2f4a6a6c61';
module.exports = node;
